import { forwardRef, type Ref } from 'react';
import { getFlexUtility, getSafeFlexProps } from './Flex.utils';
import type { FlexProps } from './Flex.types';

const Flex = forwardRef<HTMLDivElement, FlexProps>(
  (props: FlexProps, ref: Ref<HTMLDivElement>) => {
    const flexClasses: string = getFlexUtility(props);
    const safeProps = getSafeFlexProps(props);

    return (
      <div
        {...safeProps}
        className={flexClasses}
        onClick={props.onClick}
        onDragOver={props.onDragOver as any}
        onDragEnter={props.onDragEnter as any}
        onDragLeave={props.onDragLeave as any}
        onDrop={props.onDrop as any}
        ref={ref}
        role={props.role}
      >
        {props.children}
      </div>
    );
  },
);

Flex.displayName = 'Flex';

export { Flex };
